import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from 'react-router';
import "./hm-theme.css";

const ArchiveEmployeeModal = ({ isOpen, onRequestClose, employeeId }) => {
  const [loading, setLoading] = useState(false);
  const token = JSON.parse(localStorage.getItem("data")).token;
  const navigate = useNavigate();

  const handleArchive = async () => {
    setLoading(true);
    try {
      await axios.post(`/api/employeedetails/update`,
        { id: employeeId, archive: true },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Employee archived successfully");
      onRequestClose();
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">archive</i>
          Archive Employee
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}

        <div className="mb-3 p-3 rounded-3 d-flex align-items-start gap-3" style={{ background: "rgba(255, 193, 7, 0.08)", border: "1px solid rgba(255, 193, 7, 0.3)" }}>
          <i className="material-icons text-warning mt-1" style={{ fontSize: "1.4rem" }}>warning_amber</i>
          <div>
            <p className="fw-semibold mb-1">Cannot Delete This Employee</p>
            <p className="text-muted small mb-0">
              Deleting this employee would result in data loss. Please archive the employee instead — their records will be preserved but they will be deactivated from the system.
            </p>
          </div>
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
            Cancel
          </Button>
          <button className="btn-hm-primary" style={{ background: "var(--hm-gradient, linear-gradient(135deg,#2f3a88,#1a2460))" }} onClick={handleArchive} disabled={loading}>
            <i className="material-icons" style={{ fontSize: "1rem" }}>archive</i>
            Archive Employee
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ArchiveEmployeeModal;
